import { createContext, useContext } from "react";

type PendingEditsSyncContextType = {
  flushPendingEdits: () => Promise<boolean>;
  pauseSync: () => void;
  resumeSync: () => void;
  // Mutable version counter. Increment to tell all trackers to re-baseline on the next form change.
  trackerResetVersionRef: React.RefObject<number>;
};

const defaultVersionRef = { current: 0 };

export const PendingEditsSyncContext = createContext<PendingEditsSyncContextType>({
  flushPendingEdits: () => Promise.resolve(true),
  pauseSync: () => undefined,
  resumeSync: () => undefined,
  trackerResetVersionRef: defaultVersionRef
});

export const usePendingEditsSyncContext = () => useContext(PendingEditsSyncContext);
